import { jsPDF } from "jspdf";

const GUIDES = {
  student: {
    title: "Placement Readiness Guide",
    sub: "For college students & fresh graduates",
    sections: [
      ["1. Pick a role, not just a degree", ["Shortlist 1-2 job roles you actually want (e.g. Sales Executive, Accountant, AI Operator).", "Read 10 real job posts for that role and list the skills that repeat.", "Those repeating skills are your learning plan."]],
      ["2. Build proof, not just marks", ["Finish one job-linked course and earn its certificate.", "Create 2-3 small work samples: a sales pitch, a Tally ledger, a design, a presentation.", "Keep everything in one folder or link you can share on WhatsApp."]],
      ["3. A one-page CV that gets calls", ["Top: name, phone, email, city, target role.", "Skills section first, written with the same words as the job posts.", "Projects and certificates next; education last."]],
      ["4. Crack the first interview", ["Prepare a 60-second 'tell me about yourself' around the role.", "Practise 10 common questions aloud, in the language of the interview.", "Research the company, dress neatly, reach 10 minutes early."]],
      ["5. Your next step", ["Book your free career consultation with Classroom to Corporate.", "We map you to a course linked to a real opening, so your job is confirmed first."]],
    ],
  },
  employer: {
    title: "Smart Fresher Hiring Checklist",
    sub: "For hiring companies & HR teams",
    sections: [
      ["1. Define the role clearly", ["Write the 5 tasks the person will do in the first 90 days.", "Convert tasks into must-have skills vs. nice-to-have skills.", "Fix salary band, joining date and location up front."]],
      ["2. Screen for skills, not CVs", ["Use a short practical task (call script, ledger entry, design brief).", "Score every candidate on the same 3-4 criteria.", "Invite only the top scorers to interviews."]],
      ["3. Cut early attrition", ["Share a realistic job preview: hours, targets, growth path.", "Plan a 2-week onboarding with a named buddy.", "Check in at day 7, day 30 and day 90."]],
      ["4. Train before they join", ["Pre-joining training on your tools and processes saves weeks of productivity.", "Candidates who invest in training show higher commitment."]],
      ["5. Your next step", ["Book your free hiring consultation with Classroom to Corporate.", "We train candidates on your exact requirements and send only shortlisted, skill-tested profiles."]],
    ],
  },
  expert: {
    title: "Industry Trainer Starter Kit",
    sub: "For professionals who want to teach",
    sections: [
      ["1. Choose a teachable outcome", ["Pick one job skill you use daily and can explain simply.", "Phrase it as an outcome: 'After this course you can ...'.", "Keep the first course to 6-10 short lessons."]],
      ["2. Structure every lesson", ["Hook (2 min): a real workplace problem.", "Teach (10-15 min): the method, step by step.", "Practise (5 min): a task learners do immediately."]],
      ["3. Make it job-focused", ["Use real documents, scripts, tools and examples from your industry.", "End each module with a quiz that mirrors interview questions.", "Share mistakes you have seen freshers make."]],
      ["4. Set your rate and schedule", ["Start with 2-4 hours a week that you can sustain.", "Set an hourly rate that reflects your experience.", "Batch recordings on one day; keep one live Q&A slot."]],
      ["5. Your next step", ["Book your free onboarding call with Classroom to Corporate.", "We help shape your first course, bring motivated students and handle certificates."]],
    ],
  },
};

const AMBER = [224, 90, 16];

export function downloadGuide(segment, name) {
  const g = GUIDES[segment];
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();
  doc.setFillColor(...AMBER);
  doc.rect(0, 0, w, 110, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("CLASSROOM TO CORPORATE", 48, 42);
  doc.setFontSize(24);
  doc.text(g.title, 48, 74);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text(`${g.sub}${name ? ` · Prepared for ${name}` : ""}`, 48, 94);
  let y = 150;
  g.sections.forEach(([head, points]) => {
    if (y > h - 120) { doc.addPage(); y = 60; }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(15, 23, 42);
    doc.text(head, 48, y);
    y += 20;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(51, 65, 85);
    points.forEach((p) => {
      const lines = doc.splitTextToSize(`•  ${p}`, w - 110);
      doc.text(lines, 60, y);
      y += lines.length * 15 + 4;
    });
    y += 14;
  });
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139);
  doc.text("support@classroom2corporate.online  ·  Prepared by & all rights reserved to Darshan Thakkar", w / 2, h - 30, { align: "center" });
  doc.save(`${g.title.replace(/[^a-z0-9]/gi, "_")}.pdf`);
}
